import React from "react";
import Unleash from "./Unleash";
// @ts-ignore
export default React.createContext(Unleash);
